const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/client-reports.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/client-reports")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});